'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _immutable = require('immutable');

var _FormattedJSXMessage = require('I18n/components/FormattedJSXMessage');

var _FormattedJSXMessage2 = _interopRequireDefault(_FormattedJSXMessage);

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _hasMessages = require('conversations-schema/thread-history/operators/hasMessages');

var _getColoring = require('conversations-schema/operators/widget-data/getColoring');

var _hasVisitorReply = require('conversations-schema/thread-history/operators/hasVisitorReply');

var _onlyBotMessagesAreInitialMessages = require('conversations-schema/thread-history/operators/onlyBotMessagesAreInitialMessages');

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var _getBotResponder = require('conversations-schema/operators/widget-data/getBotResponder');

var _findAssignedResponder = require('conversations-schema/thread/operators/findAssignedResponder');

var _BrandingLink = require('./BrandingLink');

var _BrandingLink2 = _interopRequireDefault(_BrandingLink);

var _ChatFeed = require('./ChatFeed');

var _ChatFeed2 = _interopRequireDefault(_ChatFeed);

var _ChatAreaFooter = require('./ChatAreaFooter');

var _ChatAreaFooter2 = _interopRequireDefault(_ChatAreaFooter);

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _strings = require('conversations-schema/constants/strings');

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _colors = require('HubStyleTokens/colors');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'ChatArea',

  propTypes: {
    alert: _react.PropTypes.node,
    assignedResponder: (0, _RecordPropType2.default)('Responder'),
    attachments: _react.PropTypes.instanceOf(_immutable.Map).isRequired,
    chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
    chatInputChanged: _react.PropTypes.func,
    companyName: _react.PropTypes.string,
    consentToCommunicateMessage: _react.PropTypes.string,
    consentToProcess: _react.PropTypes.func,
    currentChannel: _react.PropTypes.string,
    currentConversation: (0, _RecordPropType2.default)('Conversation').isRequired,
    fetchChatHistory: _react.PropTypes.func,
    hasCapturedVisitorEmail: _react.PropTypes.bool.isRequired,
    hasGivenConsentToProcess: _react.PropTypes.bool.isRequired,
    hasUnansweredQuickReplyMessage: _react.PropTypes.bool,
    liveChatLink: _react.PropTypes.string,
    maxAttachmentFileSize: _react.PropTypes.number.isRequired,
    mobile: _react.PropTypes.bool,
    networkOffline: _react.PropTypes.bool.isRequired,
    onAttachmentButtonClick: _react.PropTypes.func,
    onAttachmentClick: _react.PropTypes.func.isRequired,
    onLinkClick: _react.PropTypes.func.isRequired,
    onRemoveAttachment: _react.PropTypes.func.isRequired,
    onSelectAttachmentFiles: _react.PropTypes.func.isRequired,
    potentialResponders: _react.PropTypes.instanceOf(_immutable.List),
    preview: _react.PropTypes.bool,
    publishMessage: _react.PropTypes.func,
    republishMessage: _react.PropTypes.func,
    requiresConsentToCommunicate: _react.PropTypes.bool,
    requiresExplicitConsentToProcess: _react.PropTypes.bool,
    responders: _react.PropTypes.instanceOf(_immutable.Map),
    sendFromResponders: _react.PropTypes.instanceOf(_immutable.List),
    sendVisitorEmailAddress: _react.PropTypes.func,
    showTypingIndicator: _react.PropTypes.bool,
    stagedAttachments: _react.PropTypes.instanceOf(_immutable.List),
    supportsAttachments: _react.PropTypes.bool.isRequired,
    systemOnline: _react.PropTypes.bool,
    threadHistory: (0, _RecordPropType2.default)('ThreadHistory'),
    typingResponder: (0, _RecordPropType2.default)('Responder'),
    userId: _react.PropTypes.number,
    widgetData: (0, _RecordPropType2.default)('WidgetData').isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      attachments: (0, _immutable.Map)(),
      onAttachmentClick: function onAttachmentClick() {},
      onLinkClick: function onLinkClick() {},
      chatInputChanged: function chatInputChanged() {},
      onRemoveAttachment: function onRemoveAttachment() {},
      onSelectAttachmentFiles: function onSelectAttachmentFiles() {},
      publishMessage: function publishMessage() {},
      publishChatMessage: function publishChatMessage() {}
    };
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var lastChannel = prevProps.currentChannel;
    var _props = this.props,
        currentChannel = _props.currentChannel,
        fetchChatHistory = _props.fetchChatHistory;


    if (currentChannel !== lastChannel && lastChannel !== _strings.STUBBED_CHANNEL) {
      fetchChatHistory();
    }
  },
  hasChatHistory: function hasChatHistory() {
    var threadHistory = this.props.threadHistory;


    return threadHistory && (0, _hasMessages.hasMessages)(threadHistory);
  },
  chatAreaShouldBeDisabled: function chatAreaShouldBeDisabled() {
    var _props2 = this.props,
        preview = _props2.preview,
        hasUnansweredQuickReplyMessage = _props2.hasUnansweredQuickReplyMessage,
        systemOnline = _props2.systemOnline,
        currentConversation = _props2.currentConversation,
        threadHistory = _props2.threadHistory,
        widgetData = _props2.widgetData,
        responders = _props2.responders;


    if (!currentConversation || preview || hasUnansweredQuickReplyMessage) {
      return true;
    }

    var currentResponder = (0, _findAssignedResponder.findAssignedResponder)({
      thread: currentConversation,
      responders: (0, _responderGetters.getAgentRespondersList)(responders),
      botResponder: (0, _getBotResponder.getBotResponder)(widgetData)
    });

    return Boolean(systemOnline && !this.hasChatHistory() ||
    // This locks down the message input until the bot has responded at least once
    (0, _responderGetters.getIsBot)(currentResponder) && (0, _hasVisitorReply.hasVisitorReply)(threadHistory) && (0, _onlyBotMessagesAreInitialMessages.onlyBotMessagesAreInitialMessages)(threadHistory));
  },
  renderWidgetBranding: function renderWidgetBranding() {
    var _props3 = this.props,
        liveChatLink = _props3.liveChatLink,
        onLinkClick = _props3.onLinkClick,
        showingHsBranding = _props3.widgetData.showingHsBranding;


    if (showingHsBranding) {
      return _react2.default.createElement(
        'div',
        { className: 'text-center m-bottom-2' },
        _react2.default.createElement(_UIIcon2.default, { name: 'sprocket', className: 'm-right-1', color: _colors.LORAX }),
        _react2.default.createElement(
          _Small2.default,
          { use: 'help' },
          _react2.default.createElement(_FormattedJSXMessage2.default, {
            message: 'conversationsUI.chatArea.branding_jsx',
            elements: { Link: _BrandingLink2.default },
            options: {
              href: liveChatLink,
              onClick: onLinkClick
            }
          })
        )
      );
    }
    return null;
  },
  renderChatFeed: function renderChatFeed() {
    return _react2.default.createElement(_ChatFeed2.default, {
      assignedResponder: this.props.assignedResponder,
      attachments: this.props.attachments,
      onAttachmentClick: this.props.onAttachmentClick,
      channel: this.props.currentChannel,
      chatHeadingConfig: this.props.chatHeadingConfig,
      companyName: this.props.companyName,
      consentToCommunicateMessage: this.props.consentToCommunicateMessage,
      currentConversation: this.props.currentConversation,
      currentRole: _senderTypes.VISITOR,
      systemOnline: this.props.systemOnline,
      coloring: (0, _getColoring.getColoring)(this.props.widgetData),
      hasVisitorEmail: this.props.hasCapturedVisitorEmail,
      threadHistory: this.props.threadHistory,
      fetchNextHistory: this.props.fetchChatHistory,
      potentialResponders: this.props.potentialResponders,
      sendFromResponders: this.props.sendFromResponders,
      publishMessage: this.props.publishMessage,
      republishMessage: this.props.republishMessage,
      requiresConsentToCommunicate: this.props.requiresConsentToCommunicate,
      requiresExplicitConsentToProcess: this.props.requiresExplicitConsentToProcess,
      responders: this.props.responders,
      showTypingIndicator: this.props.showTypingIndicator,
      sendVisitorEmailAddress: this.props.sendVisitorEmailAddress,
      typingResponder: this.props.typingResponder,
      userId: this.props.userId,
      widgetData: this.props.widgetData
    });
  },
  renderAlert: function renderAlert() {
    if (!this.props.alert) {
      return null;
    }

    return _react2.default.createElement(
      'div',
      null,
      this.props.alert
    );
  },
  renderFooter: function renderFooter() {
    var _props4 = this.props,
        _props4$widgetData = _props4.widgetData,
        coloring = _props4$widgetData.coloring,
        showingHsBranding = _props4$widgetData.showingHsBranding,
        chatInputChanged = _props4.chatInputChanged,
        mobile = _props4.mobile,
        networkOffline = _props4.networkOffline,
        publishMessage = _props4.publishMessage,
        consentToProcess = _props4.consentToProcess,
        onSelectAttachmentFiles = _props4.onSelectAttachmentFiles;


    var disableInput = this.chatAreaShouldBeDisabled();

    var editorClassName = (0, _classNames2.default)('input-container', 'm-bottom-2', {
      'no-branding': !showingHsBranding
    });

    return _react2.default.createElement(_ChatAreaFooter2.default, {
      consentToProcess: consentToProcess,
      editorClassName: editorClassName,
      showingHsBranding: showingHsBranding,
      publishMessage: publishMessage,
      coloring: coloring,
      disabled: disableInput,
      chatInputChanged: chatInputChanged,
      mobile: mobile,
      networkOffline: networkOffline,
      currentRole: _senderTypes.VISITOR,
      widgetData: this.props.widgetData,
      stagedAttachments: this.props.stagedAttachments,
      supportsAttachments: this.props.supportsAttachments,
      onAttachmentButtonClick: this.props.onAttachmentButtonClick,
      onRemoveAttachment: this.props.onRemoveAttachment,
      onSelectAttachmentFiles: onSelectAttachmentFiles,
      maxAttachmentFileSize: this.props.maxAttachmentFileSize,
      hasUnansweredQuickReplyMessage: this.props.hasUnansweredQuickReplyMessage,
      hasGivenConsentToProcess: this.props.hasGivenConsentToProcess
    });
  },
  render: function render() {
    return _react2.default.createElement(
      'div',
      { className: 'chat-area' },
      this.renderChatFeed(),
      this.renderAlert(),
      this.renderFooter(),
      this.renderWidgetBranding()
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/ChatArea.js
// module id = 1076
// module chunks = 2 3